// collect-remote-evidence-without-throwing.ts
//
// `collectRemoteEvidence` reports expected failures (no PAT, 401, timeout) as
// `resource_missing`/`not_found`, but a throwing dependency — a PAT lookup that
// shells out to a credential helper, a fetch that rejects outside the guarded
// path — used to escape as an uncaught rejection (stack trace, `run` dies).
// Both release legs (the pre-G3 flow and the approved-G3 CI check) call this
// instead: a throw becomes `resource_missing` with a clean reason, which each
// leg already maps to a blocked state (round 2 L5).
import { clipUntrustedText } from "./clip-untrusted-text.js";
import {
  type CollectRemoteEvidenceDeps,
  type CollectRemoteEvidenceInput,
  collectRemoteEvidence,
  type RemoteEvidenceResult,
} from "./review-remote-adapter.js";

export async function collectRemoteEvidenceWithoutThrowing(
  input: CollectRemoteEvidenceInput,
  deps?: CollectRemoteEvidenceDeps,
): Promise<RemoteEvidenceResult> {
  try {
    return await collectRemoteEvidence(input, deps);
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    return {
      kind: "resource_missing",
      reason: `Lỗi khi lấy bằng chứng MR/CI từ host: ${clipUntrustedText(message, 300)}`,
    };
  }
}
